var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "School-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 130,
            model: _vm.edit,
            elem: _vm.blackListElem,
            rules: _vm.blackListRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "微信标识", prop: "openid" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入微信标识",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.openid,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "openid",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.openid",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "ip", prop: "ip" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入ip",
                              maxlength: "15",
                            },
                            model: {
                              value: _vm.edit.ip,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "ip",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.ip",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注", prop: "remarks" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                            },
                            model: {
                              value: _vm.edit.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remarks", $$v)
                              },
                              expression: "edit.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }